import MyTabs from '../../../components/MyTabs';
import Education from './Education';
import Personalia from './Personalia';
import Preface from './Preface';
import TeachingInfra from './TeachingInfra';
// import Specifications from './Specifications';

const Introduction = (props) => {
  
    const tabs = [
        { id: "preface", title: "Preface", Component: Preface },
        { id: "personalia", title: "Personalia" , Component: Personalia},
        { id: "education", title: "Education" , Component: Education},
        { id: "teaching-infra", title: "Teaching & Infrastructure-Building" , Component: TeachingInfra},
      ];

return (
    <>
        <MyTabs list={tabs}/>
    </>
)
};

export default Introduction;